<template lang="pug">
  dv-form(
    v-model="formData"
    :schema="schema"
    :nestable="false"
    v-slot="{ fields }"
  )
    v-row
      v-col(cols="12")
        p optionsFormData: {{ formData }}
    v-row.gap-12.my-4(no-gutters)
      v-col(cols="12")
        dv-form-field(
          :field="fields.mix"
        )
      v-col(cols="12")
        dv-form-field(
          :field="fields.multiple"
        )
    v-row
      v-col(cols="6")
        dv-form-field(
          :field="fields.score"
        )
    v-row
      v-col(cols="12")
        dv-form-field(
          :field="fields.options"
        )
</template>

<script>
import DvForm from '@/packages/ui/components/forms/DvForm.vue';
import DvFormField from '@/packages/ui/components/forms/DvFormField.vue';
import DvSwitchBlock from '@/packages/ui/components/inputs/switch/DvSwitchBlock.vue';
import DvNumberField from '@/packages/ui/components/inputs/DvNumberField.vue';

import OptionsList from '../lists/OptionsList.vue';

export default {
  components: {
    DvForm,
    DvFormField,
    DvNumberField,
    OptionsList,
  },
  props: {
    value: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      formData: {
        mix: false,
        multiple: false,
        options: this.value,
      },
    };
  },
  computed: {
    schema() {
      const { score, multiple } = this.formData;

      return [
        {
          name: 'mix',
          value: 'mix',
          label: 'Перемешать варианты ответа',
          component: DvSwitchBlock,
          props: {
            filled: true,
          },
        },
        {
          name: 'multiple',
          value: 'multiple',
          label: 'Разрешить выбор нескольких вариантов',
          component: DvSwitchBlock,
          props: {
            filled: true,
          },
        },
        {
          name: 'score',
          value: 'score',
          label: 'Баллов за ответ',
          rules: 'required',
          component: DvNumberField,
          props: {
            min: 1,
            max: 999,
          },
        },
        {
          name: 'options',
          value: 'options',
          component: OptionsList,
          props: {
            selectedCorrect: true,
            multiple,
            score,
          },
        },
      ];
    },
  },
  watch: {
    value: {
      handler(val) {
        this.formData.options = val;
      },
      immediate: true,
    },
    'formData.options': {
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
